import { render, staticRenderFns } from "./ProvinceTem.vue?vue&type=template&id=243767cb&scoped=true"
import script from "./ProvinceTem.vue?vue&type=script&lang=js"
export * from "./ProvinceTem.vue?vue&type=script&lang=js"
import style0 from "./ProvinceTem.vue?vue&type=style&index=0&id=243767cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243767cb",
  null
  
)

export default component.exports